import React from 'react'

import {
  ContainerProps,
  Icon,
} from './types'

import Grid from './index.presentational'

const GridContainer: React.FC<ContainerProps> = ({ icons: iconsProp }): React.ReactElement => {
  const icons = iconsProp.map(icon => ({
    theme: typeof icon === 'string' ? icon : icon.theme,
    title: typeof icon === 'string' ? undefined : icon.title,
  }) as Icon)

  return React.createElement(
    Grid,
    { icons },
  )
}

export * from './types'

export default GridContainer
